export var MARKETING_AND_ANALYTICS_CATEGORIES = [
    'A/B Testing',
    'Analytics',
    'Attribution',
    'Email',
    'Enrichment',
    'Heatmaps & Recordings',
    'Raw Data',
    'Realtime Dashboards',
    'Referrals',
    'Surveys',
    'Video'
];
export var ADVERTISING_CATEGORIES = ['Advertising', 'Tag Managers'];
export var FUNCTIONAL_CATEGORIES = [
    'CRM',
    'Customer Success',
    'Deep Linking',
    'Helpdesk',
    'Livechat',
    'Performance Monitoring',
    'Personalization',
    'SMS & Push Notifications',
    'Security & Fraud'
];
